import { GetRequest } from "../hooks/ApiHandler"
import { useQuery } from "react-query"
import useLocalStorageState from "use-local-storage-state"
import { useNavigate } from "react-router-dom"

const fetchContacts = async ({ customer, headers, extras }) => {
    const res = await GetRequest(
        `quotation/fetchContacts/${customer?.customer_details?.id}/${customer.customer_details.customer_id}/${customer.customer_details?.user_type}`,
        { headers },
        extras
    );

    if (!res || res.status !== "success") return [];

    return res.data.map((contact) => ({
        contact_name: contact.contact_full_name,
        contactId: contact.id,
    }));
};

const fetchCompanies = async ({ customer, headers, extras }) => {
    const res = await GetRequest(
        `company/fetchCompanies/${customer.customer_details?.customer_id}`,
        { headers },
        extras
    );

    if (!res || res.success === false) return [];

    return res.data.map((c) => ({
        company_name: c.company_name,
        company_id: c.id,
    }));
};

const fetchLeadOwners = async ({ customer, headers, extras }) => {
    const res = await GetRequest(
        `users/users/fetchUserAsOwner/${customer.customer_details?.customer_id}`,
        { headers },
        extras
    );

    if (!res || res.err) return [];

    return res.data.map((lead) => ({
        leadName: lead.full_name,
        leadId: lead.id,
    }));
};

const fetchLeadSource = async ({ customer, headers, extras }) => {
    const res = await GetRequest(
        `masters/getAllLead_source/${customer.customer_details?.customer_id}`,
        { headers },
        extras
    );

    if (!res || res.success === false) return [];

    return res.data.map((lead) => ({
        source_title: lead.source_title,
        lead_source_id: lead.id,
    }));
};


export default function useCommonData(config) {
    const [customer, setCustomer] = useLocalStorageState('customer')
    const navigate = useNavigate()
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication

    // API headers configuration
    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }

    const { data: leadOwner } = useQuery({
        queryKey: ['leadOwners', customer?.customer_details?.customer_id],
        queryFn: () => fetchLeadOwners({ customer, headers, extras }),
        enabled: config.leadOwner && !!customer,
    });

    const { data: lead_source } = useQuery({
        queryKey: ['leadSources', customer?.customer_details?.customer_id],
        queryFn: () => fetchLeadSource({ customer, headers, extras }),
        enabled: config.leadSource && !!customer,
    });

    const { data: company } = useQuery({
        queryKey: ['companies', customer?.customer_details?.customer_id],
        queryFn: () => fetchCompanies({ customer, headers, extras }),
        enabled: config.companies && !!customer,
    });

    const { data: contacts } = useQuery({
        queryKey: ['contacts', customer?.customer_details?.customer_id],
        queryFn: () => fetchContacts({ customer, headers, extras }),
        enabled: config.contacts && !!customer,
    });

    return { leadOwner, lead_source, company, contacts };
}